import React, { useCallback, useEffect} from 'react';
import { connect } from "react-redux";
import { setModal } from "../../../actions/index";
import { showShortcuts } from "./redux/actions/index";

import useKeyPress from '../../../hooks/useKeyPress';

import ShortcutsPanel from './ShortcutsPanel';

// Create a shortcut to open the modal shortcuts panel (all shortcuts available)
function ConnectedShortcutsPanelWrapper({ showShortcutsPanel, setModal, showShortcuts, stateShortcuts }) {

  const keyToggle = useKeyPress('?', false, false, false, true);

  const showPanel = useCallback(() => {
    const onClose = () => { showShortcuts(false) }
    setModal({
      content: <ShortcutsPanel onClose={onClose} />,
      underlayClickExits: false
    })
  }, [setModal, showShortcuts]);

  useEffect(() => {
    if ((showShortcutsPanel || keyToggle) && stateShortcuts) { showPanel() }
  }, [showShortcutsPanel, showPanel, keyToggle, stateShortcuts])

  return null;
}

const ShortcutsPanelWrapper = connect(
  state => ({
    showShortcutsPanel: state.showShortcuts,
    stateShortcuts: state.stateShortcuts
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    showShortcuts: state => dispatch(showShortcuts(state))
  })
)(ConnectedShortcutsPanelWrapper);

export default ShortcutsPanelWrapper;
